import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../consts/api";

export const useLeadArConfig = (options) => {
  const res = useQuery(
    [QUERY_KEYS.leadArIntegration],
    () => http.get(HTTP_ENDPOINTS.leadArIntegration.getLeadArConfig()),
    {
      cacheTime: 0,
      select: (data) => ({
        accountId: data.data.data.account_id,
        createdAt: data.data.data.created_at,
        isEnabled: data.data.data.is_enabled,
        locationId: data.data.data.location_id,
        updatedAt: data.data.data.updated_at,
      }),
      ...options,
    },
  );
  return res;
};
